export * from './allocation.module';
